import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import "./POSContext.css";

function POSContext({ user }) {
  const [isSaving, setIsSaving] = useState(false);
  const [generalContext, setGeneralContext] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);  // New state for expand/collapse

  const placeholderText = `Point of Sale Context`;
  const typingTimer = useRef(null);
  const nameInputRef = useRef(null);

  const handleSave = async () => {
    setIsSaving(true);

    const inputText = nameInputRef.current.value;
    const jwt_token = localStorage.getItem('jwt_authorization');

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/system-prompt/pos_context`, {
        input_text: inputText,
        jwt_token,
      });
    } catch (error) {
      console.error('Failed to update:', error);
    }

    setIsSaving(false);
  };

  const handleInputChange = (e) => {
    if (typingTimer.current) {
      clearTimeout(typingTimer.current);
    }
    typingTimer.current = setTimeout(handleSave, 2000);
  };

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_BACKEND_HOST}/system-prompt/pos_context`, {
      jwt_token: localStorage.getItem('jwt_authorization'),
    })
      .then(response => {
        setGeneralContext(response.data);
      })
      .catch(error => {
        console.error('Error fetching pos_context', error);
      });
  }, [user]);

  const handleToggleClick = () => {
    setIsExpanded(!isExpanded);  // Toggle the state
  };

  return (
    <div className='general-context-container'>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline", justifyContent: "space-between" }} >
        <span className='general-info-label'>Point of Sale Context</span>
        <div onClick={handleToggleClick} style={{ cursor: "pointer"}} >toggle</div>
      </div>
      {isExpanded && (  // Conditionally render the textarea
        <textarea
          ref={nameInputRef}
          className="general-context"
          placeholder={placeholderText}
          defaultValue={generalContext}
          onChange={handleInputChange}
        />
      )}
      <div className='general-context-status-wrapper'>
        {isSaving && <img className="saving-animation" src="/images/saving.gif" alt="Saving..." />}
      </div>
    </div>
  );
}

export default POSContext;
